<template>
  <div class="Evaluate">
    <el-image :src="src">
      <div slot="placeholder" class="image-slot">
        加载中<span class="dot">...</span>
      </div>
    </el-image>
  </div>
</template>

<script>
  import { getEvaluat } from "@/api/evaluation";
  export default{
    data(){
      return{
        src:'',
      }
    },
    mounted(){
      if(this.$route.params.code){
        let msgs = this.$route.params.code;
        getEvaluat({shortKey:decodeURIComponent(msgs)}).then(
          response => {
            this.src = response.msg;
          }
        );
      }
    },
    methods:{

    }
  }
</script>
<style lang="scss">
.Evaluate{
	text-align: center;line-height: 30px;max-width: 760px;margin: 0 auto;
	.el-image{
		img{max-width: 100%!important;}
	}
}
</style>
